import commonMutations from '@/store/ui/common/mutations'
import Vue from 'vue'

const mutations = {
    ...commonMutations,
    // Monitoring
    setIsLoading(state, { isLoading }) {
        Vue.set(state, 'isLoading', isLoading)
    },

    // Loading on DateEntry Creation or Edition
    setNotReadyIsLoading(state, { isLoading }) {
        state.notReadyIsLoading = isLoading
    },

    // Forms
    setNextStep(state) {
        Vue.set(state, 'activeStep', state.activeStep + 1)
    },

    setPrevStep(state) {
        Vue.set(state, 'activeStep', state.activeStep - 1)
    },

    setStep(state, { step }) {
        state.activeStep = step
    },

    setConnectionId(state, { id }) {
        Vue.set(state, 'connectionId', id)
    },

    setFormIsValid(state, { type, valid }) {
        if (type !== 'all') {
            Vue.set(state.formIsValid, `${type}`, valid)
        } else {
            Vue.set(state, 'formIsValid', {
                connection: valid,
                configuration: valid
            })
        }
    },

    setFormAction(state, { action }) {
        Vue.set(state, 'formAction', action)
    },
    setFormType(state, { formType }) {
        Vue.set(state, 'formType', formType)
    },

    setFormConnection(state, { formConnection }) {
        Vue.set(state, 'formConnection', formConnection)
    },
    setFormConfiguration(state, { formConfiguration }) {
        Vue.set(state, 'formConfiguration', formConfiguration)
    },

    setEditForm(state, { action, id, formType }) {
        Vue.set(state, 'formAction', action)
        Vue.set(state, 'connectionId', id)
        Vue.set(state, 'formType', formType)
    },

    setCloseModal(state) {
        Vue.set(state, 'displayModal', false)
        Vue.set(state, 'connectionId', null)
        Vue.set(state, 'formIsValid', {
            connection: false,
            configuration: false
        })
        Vue.set(state, 'activeStep', 0)
        Vue.set(state, 'formAction', null)
        Vue.set(state, 'formType', null)
    }
}

export default mutations
